export type TableShape = 'circle' | 'square' | 'rect'

export interface Table {
  readonly id: string
  readonly name: string
  readonly shape: TableShape
  /** Unit kanvas, titik kiri-atas meja. */
  readonly x: number
  readonly y: number
  /** Kapasitas kursi; 0 = tidak diatur. */
  readonly seats: number
  readonly isOccupied?: boolean
  readonly staticQrToken?: string
  readonly dynamicQrToken?: string
  readonly dynamicQrExpiresAt?: string
  readonly isDynamicQrActive?: boolean
  readonly activeTransactions?: string[]
}

export const TABLE_SHAPES: readonly TableShape[] = ['circle', 'square', 'rect']
